import { Card as AntCard } from 'antd';
import styled from 'styled-components';

export const Card = styled(AntCard)`
  flex: 1;
  min-width: 160px;
`;
